import { useDefaultQuery } from "@/composables/utils/useTanstack";

export function getUserRoles() {
  const endpoint = "users/roles.json";
  const options = {};
  return useDefaultQuery(endpoint, {}, options);
}
